(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uk-lookbook"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.uk-lookbook--slider').forEach((root) => {
    if (root.dataset.sliderReady) return;
    root.dataset.sliderReady = 'true';
    const scroller = root.querySelector('.uk-lookbook__grid--slider');
    const prev = root.querySelector('[data-lookbook-prev]');
    const next = root.querySelector('[data-lookbook-next]');
    if (!scroller) return;
    const step = () => Math.max(scroller.clientWidth * 0.7, 160);
    prev?.addEventListener('click', () => {
      scroller.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
